import { connect } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { FaRegTimesCircle } from "react-icons/fa";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import CloseButton from "../CloseButton";

import { ShowModal } from "../../redux/v2/utils/actions";

import "./style.css";

function CustomModal(props) {
    const { modal } = props.Utils;
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 961,
                lg: 1200,
                xl: 1536,
            },
        },
    });

    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const showPopUpModal = !modal?.forceType ? !matchesMD : modal?.forceType == "popup";
    const showSliderModal = !modal?.forceType ? matchesMD : modal?.forceType == "slider";

    return (
        <div className={`custom-modal-v2 ${modal?.top ? "cm-top" : "cm-bottom"}`} id={modal?.parentID || ""}>
            {showPopUpModal && (
                <Modal id={modal?.id} className={"new-custom-modal"} show={modal?.isShow} style={{ display: "flex", margin: "auto" }} aria-labelledby="contained-modal-title-vcenter" centered contentClassName="modal-center">
                    <Modal.Header style={!modal?.title ? { padding: 0 } : {}}>
                        {
                            modal?.showCloseButton && (
                                <FaRegTimesCircle
                                    onClick={() => {
                                        props?.ShowModal(false);
                                    }}
                                />
                            )
                        }
                        {modal?.title && (
                            <Modal.Title centered id="contained-modal-title-vcenter">
                                <h4>{modal?.title}</h4>
                            </Modal.Title>
                        )}
                    </Modal.Header>

                    <Modal.Body>{modal?.body}</Modal.Body>

                    {modal?.actions?.length > 0 && (
                        <Modal.Footer>
                            {/* <div className="footer-buttons-wrapper"> */}
                            {modal?.actions
                                ? modal?.actions.map((button, i) => {
                                    return (
                                        <Button
                                            disabled={button.hasOwnProperty("disabled") ? button.disabled : false}
                                            className={`custom-btn ${button.className || ""}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                button.action();
                                            }}
                                        >
                                            {button.label}
                                        </Button>
                                    );
                                })
                                : ""}
                            {/* </div> */}
                        </Modal.Footer>
                    )}
                </Modal>
            )
            }

            {
                showSliderModal && (
                    <div
                        id={modal?.id}
                        className={`custom-slider-modal-wrapper`}
                        style={{
                            height: modal?.isShow ? "100vh" : 0,
                        }}
                        onClick={(e) => {
                            if (e.target.className == "custom-slider-modal-wrapper") {
                                props?.ShowModal(false);
                            }
                        }}
                    >
                        <div
                            className={`custom-slider-modal ${modal?.className || ""}`}
                            style={{
                                height: modal?.isShow ? modal?.height : 0,
                                paddingTop: modal?.isShow ? "10%" : 0,
                                borderTopLeftRadius: modal?.height.includes("100%") ? "0" : "10px",
                                borderTopRightRadius: modal?.height.includes("100%") ? "0" : "10px",
                                backgroundColor: modal?.bgColor || "#fff",
                                boxShadow: modal?.height.includes("100%") ? "none" : "inset 0.3em 0.3em 3em rgba(0, 0, 0, 0),0 0 0 0.3px rgb(190, 190, 190), 0em 0.3em 0.7em rgba(0, 0, 0, 0.2)",
                            }}
                        >
                            {modal?.showCloseButton && (
                                <CloseButton
                                    onClick={() => {
                                        props?.ShowModal(false);
                                    }}
                                />
                            )}

                            {modal?.body}
                        </div>
                    </div>
                )
            }
        </div >
    );
}

const mapStateToProps = (state) => ({
    Utils: state.Utils,
});

export default connect(mapStateToProps, {
    ShowModal,
})(CustomModal);
